<div class="step-container">
  <h2 class="step-title">Correo electrónico</h2>
  <p class="step-subtitle">Ingrese su dirección de correo electrónico. Le enviaremos un código de verificación.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Correo electrónico</mat-label>
      <input
        matInput
        formControlName="email"
        type="email"
        placeholder="ejemplo@correo.com"
        inputmode="email"
        autocomplete="email" />
      <mat-icon matPrefix>email</mat-icon>
      <mat-error *ngIf="form.get('email')?.hasError('required')">
        El correo electrónico es obligatorio.
      </mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('email')">
        Ingrese un correo electrónico válido.
      </mat-error>
    </mat-form-field>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="action-button"
      type="submit"
      [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">Enviar código</span>
    </button>
  </form>
</div>
